import { useState } from "react";
import { cn } from "@/lib/utils";
import styles from "./index.module.css";

type FaqItem = {
  q: string;
  a: string;
};

const FAQS: FaqItem[] = [
  {
    q: "Wait, what even is a server?",
    a: "A computer that runs 24/7 in a data center somewhere. When someone visits your URL, that computer hands them your app. It's like renting a tiny apartment on the internet for your code to live in."
  },
  {
    q: "Do I need to know Docker / Kubernetes / AWS?",
    a: "Literally no. That's the whole point. You tell us what you built, we handle the boring infrastructure stuff in the background."
  },
  {
    q: "What if my app breaks?",
    a: "Ask our AI agent (\"hey, it's returning 500s\"). It'll check logs, suggest a fix, and redeploy. Or ping a human — we hang out on Discord."
  },
  {
    q: "How is this different from Vercel or Netlify?",
    a: "Those are great until you get a $600 bill from a viral tweet. We run your app on a fixed-price server you actually own. Predictable cost, portable, no lock-in."
  },
  {
    q: "What does it cost?",
    a: "$8.79/mo for our service + the server (starts at $4/mo with Hetzner or DigitalOcean). 14 days free trial. Cancel whenever. Money back guaranteed if you're not satisfied."
  },
  {
    q: "What if my code is just on my laptop?",
    a: "We'll walk you through pushing it to GitHub. Takes about 3 minutes. Yes, we'll explain what `git push` means."
  }
];

export const FAQ2 = () => {
  const [open, setOpen] = useState<number>(0);

  const handleToggle = (i: number) => {
    setOpen(open === i ? -1 : i);
  };

  return (
    <section id="faq" className={styles.section}>
      <div className={styles.sectionHead}>
        <div className={styles.sectionKicker}>frequently asked</div>
        <h2 className={styles.sectionTitle}>
          Questions you&apos;d be
          <br />
          <em>too embarrassed to ask.</em>
        </h2>
      </div>
      <div className={styles.faqList} role="list">
        {FAQS.map((f, i) => (
          <div
            key={i}
            className={cn(styles.faqItem, open === i && styles.faqItemOpen)}
            role="listitem"
          >
            <button
              className={styles.faqQ}
              onClick={() => handleToggle(i)}
              aria-expanded={open === i}
              aria-controls={`faq-answer-${i}`}
              id={`faq-question-${i}`}
            >
              <span>{f.q}</span>
              <span className={styles.faqPlus} aria-hidden="true">
                {open === i ? "−" : "+"}
              </span>
            </button>
            {open === i && (
              <div
                className={styles.faqA}
                id={`faq-answer-${i}`}
                role="region"
                aria-labelledby={`faq-question-${i}`}
              >
                {f.a}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
